export default __webpack_public_path__ + "static/media/ddba01796cb14fff.a3a87561fcf0c70264b8812e42a9e7e2.svg";